import { render, staticRenderFns } from "./BinPackages.vue?vue&type=template&id=31b25597&scoped=true"
import script from "./BinPackages.vue?vue&type=script&lang=js"
export * from "./BinPackages.vue?vue&type=script&lang=js"
import style0 from "./BinPackages.vue?vue&type=style&index=0&id=31b25597&prod&scoped=true&lang=css"
import style1 from "./BinPackages.vue?vue&type=style&index=1&id=31b25597&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b25597",
  null
  
)

export default component.exports